import { Input } from "@progress/kendo-react-inputs";

export const DefaultValueProperty = {
  propertyName: "DefaultValue",
  propertyDisplay: "Default Value",
  propertyType: "string",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        onBlur={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || ""}
      />
    );
  },
};
